module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-26.f35d9aa7.png";